module.exports = __webpack_public_path__ + "static/img/sort-back5.f098096b.png";